export const styles = () => ({
  '.dn-menu-icon-lock': {
    fontSize: '16px !important',
    background: '#fff',
    borderRadius: '500px',
    border: '1px solid rgba(0, 0, 0, 0)',
    filter: 'drop-shadow(1px 0px 2px rgba(0, 0, 0, 0.25)) !important',
    padding: '2px',
  },

  '.DnkSidebarFooter-root': {
    width: 'calc(100% - 24px)',
  },

});
